export default `query urlResolver ($url: String!) {
  urlResolver (url: $url) {
    id
    redirectCode
    redirectCode
    type
  }
}`
